import styled from 'styled-components';
import { FontFamilyBold, FontSize14 } from '../fonts';

export const Container = styled.button`
    width: 30px;
    height: 30px;
    padding: 0;
    margin: 0;
    border-radius: 30px;
    background-image: linear-gradient(134deg, rgba(110, 193, 138, 0.99) 23%, #0e89ca 130%);
    &:hover {
        cursor: pointer;
    }
`;

export const Text = styled.p`
    margin: 0;
    padding: 0;
    line-height: 30px;
    text-align: center;
    color: white;
    ${FontFamilyBold};
    ${FontSize14};
`;